import { render, staticRenderFns } from "./commSettings.vue?vue&type=template&id=29d41d16&lang=pug&"
import script from "./commSettings.vue?vue&type=script&lang=js&"
export * from "./commSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports